import TextBlock from '@/components/atoms/text-block/text-block';
import { IRequirements } from '@/models/viewModels/IEntryRequirements';
import { RichText } from '@into-discovery/browsewebshared';
import IRichText from '@into-discovery/browsewebshared/src/models/viewModels/base/IRichText';
import Markdown from 'markdown-to-jsx';

type Props = {
  entryReqs?: IRichText;
  academicEntryReqs?: IRequirements;
  englishLanguageReqs?: IRequirements;
};

export default function EntryRequirements({
  entryReqs,
  academicEntryReqs,
  englishLanguageReqs,
}: Props) {
  return (
    <div className="row">
      {entryReqs ? (
        <div className="col-lg-7">
          <TextBlock title="Entry requirements" titleSize={3} text={entryReqs} />
        </div>
      ) : null}
      {academicEntryReqs.intro || academicEntryReqs.requirements ? (
        <div className="col-lg-6">
          <h4>Academic Entry Requirements</h4>
          {academicEntryReqs.intro ? <RichText richText={academicEntryReqs.intro} /> : null}
          {academicEntryReqs.requirements ? (
            <Markdown className="pre-wrap">{academicEntryReqs.requirements}</Markdown>
          ) : null}
        </div>
      ) : null}
      {englishLanguageReqs.intro || englishLanguageReqs.requirements ? (
        <div className="col-lg-6">
          <h4>English Language Requirements</h4>
          {englishLanguageReqs.intro ? <RichText richText={englishLanguageReqs.intro} /> : null}
          {englishLanguageReqs.requirements ? (
            <Markdown className="pre-wrap">{englishLanguageReqs.requirements}</Markdown>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
